<h2>New Releases</h2>

<h4>
  The following is a list of new releases.
  <h4>
    Click the <b> album cover </b> or <b> artist name </b> for more information.
  </h4>
</h4>

<div class="content">
  <div fxLayout="row wrap" fxLayout.xs="column">
    <!-- Single "Responsive" Card-->
    <div *ngFor="let release of releases" fxFlex [style.margin]="'20px'">
      <mat-card [style.min-width]="'200px'">
        <mat-card-header>
          <mat-card-title>{{ release.name }}</mat-card-title>
          <mat-card-subtitle>New Releases</mat-card-subtitle>
        </mat-card-header>
        <a
          class="nav-link"
          routerLink="/album/{{ release.id }}"
          routerLinkActive="active"
        >
          <img
            mat-card-image
            class="album-cover"
            src="{{ release.images[0].url }}"
            alt="album art"
          />
        </a>

        <strong>Release Date: </strong>{{ release.release_date }}<br />
        <strong>Tracks: </strong>{{ release.total_tracks }}<br /><br />
        <mat-card-content>
          <mat-chip-list
            aria-label="Artist selection"
            *ngFor="let art of release.artists"
          >
            <a
              class="nav-link"
              routerLink="artist/{{ art.id }}"
              routerLinkActive="active"
              style="text-decoration: none"
            >
              <mat-chip>{{ art.name }}</mat-chip>
            </a>
          </mat-chip-list>
        </mat-card-content>
      </mat-card>
    </div>
    <!-- -->
  </div>
</div>
